const AuditTrailAction = {
  ApplyAccountSpecificMovement: "apply-account-specific-movement",
  UpdateFleetRefs: "update-fleet-refs",
  UpdateFleetDiscount: "update-fleet-discount",
  UpdateFleetRedemptionStaitons: "update-fleet-redemption-stations",
};

export default AuditTrailAction;
